import { gql as t } from "@apollo/client";
import { LoginAccountFragment as n } from "../fragment/account.js";
const l = t`
  mutation LoginByWallet($input: LoginByWalletInput!) {
    loginByWallet(input: $input) {
      ...LoginAccount
    }
  }

  ${n}
`;
export {
  l as default
};
//# sourceMappingURL=loginByWallet.js.map
